<template>
  <v-card
    class="main--text">
    <v-container
      v-if="date"
      fluid
      grid-list-md>
      <v-row
        no-gutters
        align=center
        justify=space-between
        style="margin:0px 0px 20px 0px">
        <v-col
          cols=auto><h3>授業結果入力画面</h3></v-col>
        <v-col
          cols=auto>
        <v-icon
        @click="$emit('close-button-click')">mdi-close</v-icon>
        </v-col>
      </v-row>
      <h5>対象の先生</h5>
      <v-row
        no-gutters
        style="margin: 0px 0px 20px 0px"
        >
        <v-col
          md=8
          >
          <v-avatar>
            <img :src="teacher.iconUrl" alt="">
          </v-avatar>
          <span class="font-weight-bold"> {{ teacher.fullName() }} 先生</span>
          </v-col>
      </v-row>
      <h5>対象のお子さま</h5>
      <p style="font-size:1.2rem" class="font-weight-bold">{{student.fullName()}} さん</p>
      <v-row
        no-gutters>
        <v-col
          cols=auto
          md=6>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            :return-value.sync="stringDate">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="stringDate"
                label="授業実施日"
                prepend-icon="event"
                v-on="on"
                v-validate="'required'"
                data-vv-name="stringDate"
                data-vv-as="授業実施日"
                required
                :error-messages="errors.collect('stringDate')"
                >
              </v-text-field>
            </template>
              <v-date-picker
                v-model="stringDate"
                no-title
                scrollable
                width="360">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dateMenu.save(stringDate)">OK</v-btn>
              </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        >
        <v-menu
          ref="startMenuRef"
          v-model="startMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="start"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-col
              md=3>
            <v-text-field
              v-model="start"
              label="開始時刻"
              prepend-icon="access_time"
              readonly
              v-on="on"
              v-validate="'required'"
              data-vv-name="start"
              data-vv-as="開始時刻"
              required
              :error-messages="errors.collect('start')"
            ></v-text-field>
            </v-col>
          </template>
          <v-time-picker
            v-if="startMenu"
            v-model="start"
            :allowed-minutes="allowedMinutes"
            full-width
            @click:minute="$refs.startMenuRef.save(start)"
          ></v-time-picker>
        </v-menu>
        <v-menu
          ref="endMenuRef"
          v-model="endMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="end"
          transition="scale-transition"
          offset-y
          full-width
        >
          <template v-slot:activator="{ on }">
            <v-col
              md=3>
            <v-text-field
              v-model="end"
              label="終了時刻"
              prepend-icon="access_time"
              readonly
              v-on="on"
              v-validate="'required'"
              data-vv-name="end"
              data-vv-as="終了時刻"
              required
              :error-messages="errors.collect('end')"
            ></v-text-field>
            </v-col>
          </template>
          <v-time-picker
            v-if="endMenu"
            v-model="end"
            :allowed-minutes="allowedMinutes"
            full-width
            @click:minute="$refs.endMenuRef.save(end)"
          ></v-time-picker>
        </v-menu>
      </v-row>
      <v-row
        no-gutters>
        <v-col
          cols=12
          md=6>
          <v-select
            v-model="wage"
            :items="wageRange"
            label="報酬（円）"
            v-validate="'required'"
            data-vv-name="wage"
            data-vv-as="報酬額"
            required
            :error-messages="errors.collect('wage')"
            >
          </v-select>
        </v-col>
      </v-row>
      <v-row
        no-gutters>
        <v-col>
          <v-textarea
          v-model="note"
          label="コメント"
          outlined></v-textarea>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify=end>
        <v-col
          cols=auto>
          <v-btn
            depressed
            outlined
            rounded
            @click="submit">
            確定
      </v-btn>
        </v-col>
      </v-row>
    </v-container>
      <v-dialog
        :value="fixed"
        width="300">
        <v-card>
          <v-container>
            <v-row
              
              justify=center>
              <v-col
                cols=auto>
                登録完了しました！
              </v-col>
            </v-row>
            <v-row
              ustify=center>
              <v-col
                cols=auto>
                <v-btn
                  depressed
                  rounded
                  outlined
                  color="primary"
                  @click="closeResult">OK</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
  </v-card>
</template>

<script>
import { LessonRecordRepository } from "@/repository/LessonRecordRepository"
import { firestore } from "@/repository/client/firestore"

export default {
  props: {
    lesson: Object,
    teacher: Object,
    student: Object
  },
  data() {
    return {
      date: null,
      dateMenu: null,
      start: this.lesson.schedule.start,
      startMenu: null,
      end: this.lesson.schedule.end,
      endMenu: null,
      wage: this.lesson.wage,
      note: "",
      lessonRecordRepo: null,
      record: null,
      fixed: false
    }
  },
  methods: {
    dateToString() {
      const t = this.date.getFullYear()
      const m = this.date.getMonth() + 1
      const d = this.date.getDate()
      return t + "-" + m + "-" + d
    },
    allowedMinutes: m => m % 15 === 0,
    async submit() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.lesson.note = this.note
          this.record = await this.lessonRecordRepo.put(
            this.lesson,
            this.date,
            this.start,
            this.end,
            this.wage
          )
          this.fixed = true
        }
      })
    },
    closeResult() {
      this.fixed = false
      this.$emit("close-button-click")
    }
  },
  created: function () {
    this.date = new Date()
    this.lessonRecordRepo = new LessonRecordRepository(firestore)

  },
  computed: {
    wageRange: function () {
      var range = new Array()
      var i
      for (i = 0; i <= 200; i++) {
        range.push(i*100)
      }
      return range
    },
    stringDate: {
      get() {
        return this.dateToString()
      },
      set(stringDate) {
        this.date = new Date(stringDate)
      }
    }
  }
}
</script>
